export default __webpack_public_path__ + "static/australia_oz_lotto-eb26f9a6470a7831a5ce9f8c32607b50.png";